import * as React from 'react';
import './Home.scss';
import Portal from './../../portals/Portal';
import Header from './../../components/Header';
import HeaderBanner from 'src/components/HeaderBanner';
import TopProductCardsCarousel from './../../components/TopProductCardsCarousel/TopProductCardsCarousel';
import FrequentlyPurchasedProductsCarousel from './../../components/FrequentlyPurchasedProductsCarousel';
import FeaturedProductsCarousel from './../../components/FeaturedProductsCarousel';
import BrowsingHistoryProductsCarousel from './../../components/BrowsingHistoryProductsCarousel';
import Menu from 'src/components/Menu';
import RecentOrders from 'src/components/RecentOrders';
import ImageBanner from './../../components/ImageBanner';
import ProductInformationForm from './../../components/ProductInformationForm';
import ScrollButton from './../../components/ScrollButton';
// import Footer from '../../components/Footer';

import {
  ifLoggedIn,
  goToSearch,
  goToPartDetail,
  goToModelDetail
} from 'src/utils/navigation';
import FeedbackView from '../FeedbackView';

interface IHomeProps {
  isLoggedIn: boolean;
}

export class Home extends React.Component<IHomeProps, any> {
  private onSubmitSearch = (text: string) => {
    ifLoggedIn(() => goToSearch(text));
  };

  private onSearchSelectedPart = (text: string) => {
    ifLoggedIn(() => goToPartDetail(text));
  };

  private onSearchSelectedModel = (name: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(name, manufacturer));
  };

  public render() {
    return (
      <div>
        <Portal idElementToRender={'specialuserbanner'}>
          <HeaderBanner />
        </Portal>
        <Portal idElementToRender={'header'}>
          <Menu
            handleOnSubmitSearch={this.onSubmitSearch}
            handleOnSearchSelectedPart={this.onSearchSelectedPart}
            handleOnSearchSelectedModel={this.onSearchSelectedModel}
          />
          <FeedbackView />
        </Portal>
        <Portal idElementToRender={'searchbar'}>
          <Header
            handleOnSubmitSearch={this.onSubmitSearch}
            handleOnSearchSelectedPart={this.onSearchSelectedPart}
            handleOnSearchSelectedModel={this.onSearchSelectedModel}
          />
        </Portal>
        <Portal idElementToRender={'imagebanner'}>
          <ImageBanner
            handleOnSubmitSearch={this.onSubmitSearch}
            handleOnSearchSelectedPart={this.onSearchSelectedPart}
            handleOnSearchSelectedModel={this.onSearchSelectedModel}
          />
        </Portal>
        { this.props.isLoggedIn &&
        <Portal idElementToRender={'topProducts'}>
          <TopProductCardsCarousel isLoggedIn={this.props.isLoggedIn} />
        </Portal>
        }
        <Portal idElementToRender={'recentOrders'}>
          {this.props.isLoggedIn && <RecentOrders />}
        </Portal>
        <Portal idElementToRender={'frequentlyPurchased'}>
          {this.props.isLoggedIn ? (
            <FrequentlyPurchasedProductsCarousel />
          ) : (
            <FeaturedProductsCarousel />
          )}
        </Portal>
        <Portal idElementToRender={'browsingHistory'}>
          {this.props.isLoggedIn && <BrowsingHistoryProductsCarousel />}
        </Portal>
        <Portal idElementToRender={'productInformationForm'}>
          <ProductInformationForm />
        </Portal>
        <Portal idElementToRender={'scrollButton'}>
          <ScrollButton />
        </Portal>
        {/* <Portal idElementToRender={'footer'}>
          <Footer />
        </Portal> */}
      </div>
    );
  }
}
